export default "__VITE_ASSET__DkS1N9St__"